export const ASSESSMENT_COMPLETE_EVENT = 'eir:assessment-complete';
export const TRIGGER_HEALTH_ANALYSIS_EVENT = 'eir:trigger-health-analysis';
export const TRIGGER_CHAT_WITH_AI_EVENT = 'eir:trigger-chat-with-ai';

